
import axios from "axios";


export const OPDReportsFetch = (ids) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/v1/OPD?opdId=${ids?.opdId}&userId=${ids?.userId}`);
  };


